import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Layout Components (Create these files if you haven't yet)

// Page Components
import Home from "./Home";
import About from "./About";
import Services from "./Services";
import Contact from "./Contact";
import Work from "./work";
import OohAdvertising from "./OohAdvertising";
import TrainBranding from './TrainBranding';
import OTTAdvertising from './OTTAdvertising';
import AdShoot from './AdShoot';
import Photography from './Photography';
import Social from './SocialMediaMarketing';
import Webdesign from './Webdesign';
import NotFound from './NotFound'; 

function App() {
  return (
    <Router>
      {/* Header stays here to appear on top of every page */}
     

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/work"  element={<Work/>}/>
          <Route path="/services/unipole-hoardings" element={<OohAdvertising/>} />
          <Route path="/services/train-branding" element={<TrainBranding/>} />
          <Route path="/services/ott-advertising" element={<OTTAdvertising/>} />
          <Route path="/services/adshoot" element={<AdShoot/>} />
          <Route path="/services/ppc-marketing" element={<Photography/>} />
          <Route path="/services/social-media-marketing" element={<Social/>} />
          <Route path="/services/web-design" element={<Webdesign/>} />
          <Route path="/services" element={<Services />} />
           <Route path="/contact" element={<Contact />} />

          {/* Catch-all 404 Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {/* Footer stays here to appear at the bottom of every page */}
   
    </Router>
  );
}

export default App;